// Import necessary dependencies and utilities
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";
import { transformRequest } from "../../utils/API/requestMiddleware";

const groupMemberAPI = createApi({
    reducerPath: 'groupMemberAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        getGroupMemberByGroupId: builder.query({
            query: (groupId) => ({
                url: `/GroupMember/GetGroupMemberByGroupId?GroupId=${groupId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addGroupMember: builder.mutation({
            query: (data) => ({
                url: `/GroupMember/AddGroupMember`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteGroupMember: builder.mutation({
            query: (groupMemberId) => ({
                url: `GroupMember/DeleteGroupMember?GroupMemberId=${groupMemberId}`,
                method: 'DELETE',
                body: transformRequest(groupMemberId),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getUnassignGroupMembersbyGroupId: builder.query({
            query: (groupId) => ({
                url: `GroupMember/GetUnassignGroupMembersbyGroupId?GroupId=${groupId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

    })

});


export const {
    useLazyGetGroupMemberByGroupIdQuery,
    useAddGroupMemberMutation,
    useDeleteGroupMemberMutation,
    useLazyGetUnassignGroupMembersbyGroupIdQuery
} = groupMemberAPI;

export default groupMemberAPI;